import React from 'react'
import { View, ActivityIndicator, Text, StyleSheet } from 'react-native'
import theme from '../../../theme'

const LoadingOverlay = ({ visible = false, message = '', progressColor = theme.colors.colorPrimary, progressSize = 50 }) => {
    if (!visible) return null
    return (
        <View style={styles.container} pointerEvents='none'>
            <ActivityIndicator color={progressColor} size={progressSize} />
            {message != '' && <Text style={styles.text}>{message}</Text>}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#fff',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    text: {
        marginTop: 12,
        color: '#666',
    },
})

export default LoadingOverlay
